import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoaderService } from './shared/services/loader.service';
import { NgxSpinnerComponent, NgxSpinnerService } from 'ngx-spinner';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { IdleService } from './shared/services/idle.service';

// ngx-spinner v15 added a document:keydown listener that calls event.preventDefault()
// whenever the fullScreen spinner is visible, blocking all keyboard input.
// Override it with a no-op so users can type in inputs while data loads.
(NgxSpinnerComponent.prototype as any)['handleKeyboardEvent'] = (_event: KeyboardEvent) => {};

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less'],
    standalone: false
})

export class AppComponent implements OnInit, OnDestroy{
  
 onDestroy=new Subject<void>();

  constructor(private _loaderService: LoaderService, private ngxSpinnerService: NgxSpinnerService, private idleService: IdleService){
    this._loaderService.apiCountObservable.pipe(takeUntil(this.onDestroy)).subscribe((count: number) => {
      document.body.classList.toggle('app-loading', count > 0);
      return count > 0 ? this.ngxSpinnerService.show() : this.ngxSpinnerService.hide();
    });
    document.addEventListener('click', (event: MouseEvent) => {
      if (this._loaderService.apiCount > 0 && (event.target as HTMLElement)?.closest?.('.cdk-overlay-pane')) {
        event.stopPropagation();
        event.preventDefault();
      }
    }, true);
  }

  ngOnInit(): void {
    this.idleService.startWatching();
  }

  ngOnDestroy(): void {
  this.onDestroy.next();
  this.onDestroy.complete();
  }
  title = 'grt';
}
